module.exports = __webpack_public_path__ + "img/001.bf701eba.png";